import script from "./StartTestComponent.vue?vue&type=script&lang=ts&setup=true"
export * from "./StartTestComponent.vue?vue&type=script&lang=ts&setup=true"

import "./StartTestComponent.vue?vue&type=style&index=0&id=127aa7ed&lang=scss"

const __exports__ = script;

export default __exports__